import type { ReactElement } from "react";

import { PageSuspense } from "@/components/shared/PageSuspense";
import type { RouteSkeletonConfig } from "@/types/routeSkeleton";

export function fullscreenSuspense(
  children: ReactElement,
  skeleton?: RouteSkeletonConfig,
): ReactElement {
  return (
    <PageSuspense layout="fullscreen" skeleton={skeleton}>
      {children}
    </PageSuspense>
  );
}
